module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQMatches: 'Vos correspondances Color iQ',
        save: 'Sauvegarder'
    };

    return resources[label];
};
